var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9366 23C12.7702 23 12.6079 22.9538 12.4585 22.866C12.4158 22.8382 12.3731 22.8105 12.3304 22.7781L12.0231 22.547C11.2504 21.9646 9.43601 20.6011 8.22787 19.5888C3.64288 15.7293 1.30343 12.9467 0.859451 10.8298C0.641728 10.1272 0.517925 9.2906 0.509387 8.42625C0.483773 6.13826 1.28209 3.92424 2.70369 2.35732C3.99722 0.933682 5.69631 0.143288 7.48505 0.134043C9.52139 0.134043 11.3742 1.03537 12.6976 2.59767C13.9996 0.979904 15.8482 0.0277331 17.8589 0H17.9912C21.8163 0 24.9669 3.63304 25.0181 8.09807C25.0267 8.96242 24.9199 9.80366 24.7022 10.6033C24.3308 12.6324 21.9913 15.5675 17.5771 19.4871C15.861 21.0125 14.4821 22.1403 13.466 22.8382C13.3081 22.9445 13.1202 23 12.9366 23Z",
    fill: "#F57D7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartFill);
export default __webpack_public_path__ + "static/media/heart-fill.ea7400e67011207c058fbb297c8bfb92.svg";
export { ForwardRef as ReactComponent };